export default "appengine.logoc2c312af6aa99037.png"